export function wrapIndex(index, length) {
  if (!Number.isFinite(length) || length <= 0) return 0;
  return ((index % length) + length) % length;
}

export function adjacentIndexes(index, length) {
  if (length <= 1) return { previous: null, active: 0, next: null };

  const active = wrapIndex(index, length);
  return {
    previous: wrapIndex(active - 1, length),
    active,
    next: wrapIndex(active + 1, length),
  };
}

export function isInteractiveTarget(target) {
  if (!target || typeof target.closest !== "function") return false;
  return Boolean(
    target.closest(
      "button, a, input, textarea, select, option, [contenteditable='true'], [data-deck-interactive='true']",
    ),
  );
}
